import Header from './components/Header';
import Hero from './components/Hero';
import FaqSection from './components/FaqSection';
import MediaSection from './components/MediaSection';
import ContactSection from './components/ContactSection';
import AboutSection from './components/AboutSection';
import FeaturesSection from './components/FeaturesSection';
import CommentsSection from './components/CommentsSection';
import TopicsSection from './components/TopicsSection';
import RankingSection from './components/RankingSection';
import AppSection from './components/AppSection';
import CardsSection from './components/CardsSection';
import IndexSection from './components/IndexSection';
import CarouselSection from './components/CarouselSection';
import UpdatesSection from './components/UpdatesSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <FaqSection />
        <MediaSection />
        <ContactSection />
        <AboutSection />
        <FeaturesSection />
        <CommentsSection />
        <TopicsSection />
        <RankingSection />
        <AppSection />
        <CardsSection />
        <IndexSection />
        <CarouselSection />
        <UpdatesSection />
      </main>
      <Footer />
    </>
  );
}